import axios from '@/api';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'diary/';

class DiaryService {
    getDiaryList(params = {}) {
        return axios.get(API_URL + 'list', {
            params,
            headers: authHeader(),
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }

    getDiaryByDate(date) {
        return axios.get(API_URL + 'date/' + encodeURIComponent(date), {
            headers: authHeader(),
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }

    getDiaryById(id) {
        return axios.get(API_URL + 'detail/' + id, {
            headers: authHeader(),
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }

    createDiary(diary) {
        return axios.post(API_URL + 'create', diary, {
            headers: authHeader(),
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }

    updateDiary(diary) {
        const { diaryId, ...data } = diary;

        return axios.put(API_URL + diaryId, data, {
            headers: authHeader(),
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }

    deleteDiary(id) {
        return axios.delete(API_URL + id, {
            headers: authHeader(),
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    }
}

export default new DiaryService();